import { format, isToday } from "date-fns";
const LargeMonthViewNumbers = ({day, goToDayView}) => {
  const [year, month, date] = day.split('-').map(Number);
  const newDate = new Date(year, month - 1, date);

    return(
        <time onClick={() => goToDayView(newDate)} id="date-number" dateTime={newDate} className={isToday(newDate) ? 'flex-auto h-6 w-5 p-1 px-1.5 items-center text-center justify-center inline-block font-extrabold rounded-full text-base bg-purple-600 text-white' : 'hover:bg-gray-300 rounded-full p-1 px-1.5 inline-block w-5 text-center text-base font-extrabold cursor-pointer'}>
          {format(newDate, 'd')}
        </time>
    )
}
export default LargeMonthViewNumbers;